import React from 'react';
import { Main } from './index.styled';

export const Body = ({ children }) => <Main>{children}</Main>;
